import { render, staticRenderFns } from "./WalletList.vue?vue&type=template&id=576c60f6&scoped=true&"
import script from "./WalletList.vue?vue&type=script&lang=js&"
export * from "./WalletList.vue?vue&type=script&lang=js&"
import style0 from "./WalletList.vue?vue&type=style&index=0&id=576c60f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c60f6",
  null
  
)

export default component.exports